// extracted by mini-css-extract-plugin
export default {"button":"RjDsJ u-h9X hRgdS","title":"+ahSF"};